import { ThemeVariant } from '../types/theme-variant.enum';
export function getTeaserBackground(themeVariant: string) {
  let teaserBackground: string;
  switch (themeVariant) {
    case ThemeVariant.PRIMARY_DARK:
      teaserBackground = 'primary-dark';
      break;
    case ThemeVariant.PRIMARY_MEDIUM:
      teaserBackground = 'primary';
      break;
    case ThemeVariant.SECONDARY:
      teaserBackground = 'secondary';
      break;
    case ThemeVariant.TERTIARY:
      teaserBackground = 'tertiary';
      break;
    case ThemeVariant.PRIMARY:
      teaserBackground = 'primary';
      break;
  }
  return teaserBackground;
}

export function getAltClass(themeVariant: string) {
  let altClass: string;
  if (
    themeVariant === ThemeVariant.PRIMARY_DARK ||
    themeVariant === ThemeVariant.PRIMARY_MEDIUM ||
    themeVariant === ThemeVariant.PRIMARY
  ) {
    altClass = 'vs-alt';
  }
  return altClass;
}

export function getLinkColor(themeVariant, linkStyle) {
  let linkColor: string;
  if (linkStyle === 'button') {
    if (
      themeVariant === ThemeVariant.PRIMARY_DARK ||
      themeVariant === ThemeVariant.PRIMARY_MEDIUM ||
      themeVariant === ThemeVariant.PRIMARY
    ) {
      linkColor = 'secondary';
    } else {
      linkColor = 'primary'
    }
  }
  else {
    if (
      themeVariant === ThemeVariant.PRIMARY_DARK ||
      themeVariant === ThemeVariant.PRIMARY_MEDIUM ||
      themeVariant === ThemeVariant.PRIMARY
    ) {
      linkColor = 'vs-alt';
    }
  }
  return linkColor;
}
